function WhyMicrofinanceBazar() {
  return (
    <>
      <section class="py-8 bg-auto bg-image">
        <div class="container my-lg-8">
          <div class="row justify-content-center py-6">
            <div class="col-12">
              <div className="z-2 position-relative">
                <h1 class="mb-2 display-4 text-white fw-bold">
                  <span>Why MicrofinanceBazar</span>
                </h1>
                <ol class="breadcrumb">
                  <li class="breadcrumb-item lead">
                    <a href="#">Home</a>
                  </li>
                  <li
                    class="breadcrumb-item active lead text-white"
                    aria-current="page"
                  >
                    Why MicrofinanceBazar
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-8">
        <div className="container">
          <h1 class="fw-bold lh-1">RESEARCH and DEVELOPMENT</h1>
          <p className="lead lh-sm text-danger mb-3">
            A Profound And Personal Insight Guides Every Part Of Our Work
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            Determining impact is vital to our efforts. We employ open platforms
            and innovative technology to capture and scrutinize millions of data
            points related to customer preferences.
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            Establishing personal connections with our clients provides us with
            direct insights into the efficacy of our solutions in managing
            challenges such as climate and healthcare crises. The data we gather
            on our impact showcases how actual people view their journey towards
            breaking free from poverty.
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            Microfinance Bazar Impact Finance understands that merely providing
            access is insufficient for achieving financial well-being. True
            empowerment involves equipping individuals with the necessary tools
            to effectively utilize available products and services.
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            In India, we are enhancing Adhaar Seva Kendra to offer clients
            insights into financial literacy, consumer protection, and the
            financial products that best meet their unique requirements.
          </p>
        </div>
      </section>

      <section className="mt-7">
        <div className="container">
          <h1 class="fw-bold mb-2">
            Business Loan For Women{" "}
            <u class="text-primary">
              <span class="text-dark">Features and Benefits</span>
            </u>
          </h1>
          <p className="lead lh-sm text-danger mb-1">Loan Amounts</p>
          <p className="lead mb-3 fs-4 lh-sm">
            Ranges from ₹30000.00 (Thirty Thousand) to ₹150000.00 (1 Lakh Fifty
            Thousand) to support new rural women entrepreneurs.   Larger loan
            limits assist village women entrepreneurs in capitalizing scheme to
            obtain need based funding such as starting, operating, and expansion
            activities of their businesses.
          </p>
          <p className="lead lh-sm text-danger mb-1">
            Concessional Interest Rates
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            Programs offer reduced interest rates, e.g., 0.25% concession on
            standard rates over and above Reward Point Concessions These
            concessions can be of great relief to budding women entrepreneurs.
          </p>
          <p className="lead lh-sm text-danger mb-1">Collateral-Free Loans</p>
          <p className="lead mb-3 fs-4 lh-sm">
            Schemes do not require collateral or security except Vehicles and
            Equipment’s which are on Hypothecation till loan Repayment Closed.
            It helps the women entrepreneurs have access to debt funding without
            the requirement of collateral to promote entrepreneurship.
          </p>
          <p className="lead lh-sm text-danger mb-1">Repayment Flexibility</p>
          <p className="lead mb-3 fs-4 lh-sm">
            Offers up to 18, 28 and 42 months repayment period, accommodating
            entrepreneurial needs.
          </p>
          <p className="lead lh-sm text-danger mb-1">
            Support for Diverse Business Types
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            Available for various sectors such as manufacturing, agriculture,
            retail, etc.
          </p>
          <p className="lead lh-sm text-danger mb-1">
            Capacity Building and Skill Development
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            For some schemes MicrofinanceBazar provide training and skill
            development alongside financial assistance
          </p>
        </div>
      </section>

      <section className="mt-7">
        <div className="container">
          <h1 class="fw-bold">
            Documents Required For Business Loans For{" "}
            <u class="text-primary">
              <span class="text-dark"> Women Entrepreneurs</span>
            </u>
          </h1>
          <p className="lead lh-sm text-danger mb-1">
            For women entrepreneurs seeking quick business loans the commonly
            required documents include :
          </p>

          <table class="table table-bordered mt-5">
            <thead>
              <tr>
                <th scope="col bg-info">
                  <span className="text-dark">Identity Proof</span>
                </th>
                <th scope="col">Aadhaar Card, PAN Card, Driving Licence</th>
              </tr>
              <tr>
                <th scope="col">
                  <span className="text-dark">Address Proof</span>
                </th>
                <th scope="col">
                  Utility Bills (Electricity / Water), Government Address
                  Documents
                </th>
              </tr>
              <tr>
                <th scope="col">
                  <span className="text-dark">Business Proof</span>
                </th>
                <th scope="col">
                  Business Registration Certificate, Licenses (If Any), Field
                  Visit Verification With Pictures & Reference Validation
                </th>
              </tr>
              <tr>
                <th scope="col">
                  <span className="text-dark">Financial Documents</span>
                </th>
                <th scope="col">
                  Recent Bank Statement, Cash Book, Ledger Etc
                </th>
              </tr>
              <tr>
                <th scope="col">
                  <span className="text-dark">Business Plan</span>
                </th>
                <th scope="col">
                  Detailed plan outlining business nature, invertment,
                  Operational details
                </th>
              </tr>
              <tr>
                <th scope="col">
                  <span className="text-dark">Photographs</span>
                </th>
                <th scope="col">
                  Recent Passport-Size Photographs of applicant / Online Video
                  KYC Verification
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </section>

      <section className="mt-7">
        <div className="container">
          <h1 class="fw-bold">
            Business Loans For Women:{" "}
            <u class="text-primary">
              <span class="text-dark">Fee and Interest Rates</span>
            </u>
          </h1>
          <p className="lead lh-sm text-danger mb-1">
            The interest rates and fees associated with loans for women
            fluctuate according to the particular loan schemes launched by
            MicrofinanceBazar from time to time to enhance village women's
            entrepreneurship.
          </p>

          <table class="table table-bordered mt-5">
            <thead>
              <tr>
                <th scope="col bg-info">
                  <span className="text-dark">Customized Interest Rates</span>
                </th>
                <th scope="col">
                  Fair, Transparent – starting from 18.00% per month
                </th>
              </tr>
              <tr>
                <th scope="col">
                  <span className="text-dark">Processing Fees</span>
                </th>
                <th scope="col">2-5%</th>
              </tr>
              <tr>
                <th scope="col">
                  <span className="text-dark">Loan Tenure</span>
                </th>
                <th scope="col">Up to 42 Months</th>
              </tr>
              <tr>
                <th scope="col">
                  <span className="text-dark">Pre-closure Charges**</span>
                </th>
                <th scope="col">
                  Pre-Closure Charges upto 5% are applicable for Closure before
                  8 Months (Slab Wise 6 to 8 Months)
                </th>
              </tr>
              <tr>
                <th scope="col">
                  <span className="text-dark">Eligibility Criteria*</span>
                </th>
                <th scope="col">0 - 3 Months Start-up</th>
              </tr>
              <tr>
                <th scope="col">
                  <span className="text-dark">Loan Amount</span>
                </th>
                <th scope="col">₹ 30,000.00 – ₹ 150000.00</th>
              </tr>
              <tr>
                <th scope="col">
                  <span className="text-dark">Installments</span>
                </th>
                <th scope="col">Flexible Monthly / Bi-weekly / Fortnightly</th>
              </tr>
            </thead>
          </table>
        </div>
      </section>

      <section class="pt-lg-7 pt-5">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
              <div class="pe-lg-6">
                <span className="badge bg-danger-soft rounded-pill fs-5 px-4 mb-2">
                  Financial Inclusion
                </span>

                <h2 class="fw-semibold my-3 ls-sm lh-1">
                  Financial Assistance, Savings Programs, and Training to
                  developing Unbanked, Transgender and Physically Disabled
                  Communities.
                </h2>
                <p class="mb-3 h3 lh-1">
                  The profound effect that small loans and fundamentals of
                  Digital Financial Education by Microfinancebazar REWARDS
                  program have empowering individuals to alleviate poverty.
                </p>
                <div class="mt-3">
                  <div class="mb-2">
                    <div>
                      <p class="mb-3 fs-4 lh-sm">
                        Our microfinance model has developed into a worldwide
                        network that is changing lives across numerous
                        low-income nations.
                      </p>
                    </div>
                    <div>
                      <p class="mb-0 fs-4 lh-sm">
                        Today, <u>MICROFINANCEBAZAR</u> is at the forefront of
                        merging technology with responsible microfinance
                        practices. We are expanding our services by utilizing
                        digital tools to reach underserved communities,
                        including individuals living in the most remote regions
                        of the world.
                      </p>
                    </div>
                  </div>
                </div>
                <a
                  class="btn btn-outline-dark px-5 btn-md mt-4 mb-lg-0 mb-5"
                  href="/"
                >
                  Apply Now
                </a>

                <div className="d-flex flex-wrap mt-4 gap-1">
                  <span className="badge bg-dark-soft rounded-pill fs-5 px-4 py-2">
                    Loan Portfolio 10 Million
                  </span>
                  <span className="badge bg-dark-soft rounded-pill fs-5 px-4 py-2">
                    Loan Repayment 98%
                  </span>
                  <span className="badge bg-dark-soft rounded-pill fs-5 px-4 py-2">
                    Digita Literacy Reward Rate 85%
                  </span>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <img
                src="/assets/images/home/7.jpg"
                class="object-fit-cover w-100 rounded-5"
                height="550"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="pt-lg-7 pb-lg-3 py-5 mb-7">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
              <img
                src="/assets/images/home/5.jpg"
                class="object-fit-cover w-100 rounded-5"
                height="550"
              />
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <div class="ps-lg-6">
                <span className="badge bg-danger-soft rounded-pill fs-5 px-4 mb-2">
                  Poverty Elimination Lab
                </span>

                <h2 class="fw-semibold my-3 ls-sm lh-1">
                  Creating and Innovating powerful solutions with Artificial
                  Intelligence and Blockchain technology aiming to eliminate the
                  cycle of poverty.
                </h2>
                <div class="mt-3">
                  <div class="mb-2">
                    <div>
                      <p class="mb-3 fs-4 lh-sm">
                        The communities we serve are rich in potential, but they
                        remain constrained by persistent challenges that prevent
                        their advancement. Microfinancebazar Lab collaborates
                        closely with clients to create groundbreaking solutions
                        that empower people in crafting their own journeys
                        leading out of poverty.
                      </p>
                      <p class="mb-3 fs-4 lh-sm">
                        Once we establish that a solution can achieve remarkable
                        success in enhancing lives, we engage with partners to
                        swiftly scale these solutions for long-term and
                        sustainable impact.
                      </p>
                    </div>
                  </div>
                </div>
                <a
                  class="btn btn-outline-dark px-5 btn-md mt-4 mb-lg-0 mb-5"
                  href="/introduction"
                >
                  Request Loan
                </a>

                <div className="d-flex flex-wrap mt-4 gap-1">
                  <span className="badge bg-dark-soft rounded-pill fs-5 px-4 py-2">
                    700 M people live on less than $2.15/day
                  </span>
                  <span className="badge bg-dark-soft rounded-pill fs-5 px-4 py-2">
                    6.7 % of people in extreme poverty live in India
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-7 pb-7">
        <div className="container">
          <h1 class="fw-bold mb-2">
            How To Apply For Business{" "}
            <u class="text-primary">
              <span class="text-dark">Loan For Women?</span>
            </u>
          </h1>
          <p class="mb-3 fs-4 lh-sm">
            MicrofinanceBazar Digital Loan Application Steps for our Women
            customer involves the following steps:
          </p>
          <h3>Digital Business Loan Application Steps for Women:</h3>
          <h3>1. Access the Online Application Portal</h3>
          <ul className="lead mb-3 fs-4 lh-sm">
            <li>
              <u>How:</u> Visit the MicrofinanceBazar official website or mobile
              app and navigate to the business loan section. You can also find a
              direct link for women-focused business loans
            </li>
            <li>
              <u>What:</u> The portal will provide easy access to the loan
              application form, along with detailed guidelines on eligibility
              and required documents.
            </li>
          </ul>
          <h3>2. Complete the Online Application Form</h3>
          <ul className="lead mb-3 fs-4 lh-sm">
            <li>
              <u>How:</u> The digital form will prompt you to enter personal,
              business, and loan-specific details. The form is user-friendly and
              may include drop-down menus and auto-fill options to simplify data
              entry in 22 Major Languages spoken in India
            </li>
            <li>
              <u>What:</u> You’ll provide accurate, verifiable details, and loan
              requirements (amount, purpose, repayment terms, etc.).
            </li>
          </ul>
          <h3>3. Upload Required Documents</h3>
          <ul className="lead mb-3 fs-4 lh-sm">
            <li>
              <u>How:</u> Use the online system to upload scanned or photo
              copies of all required documents (e.g. identification, and
              self-attested documents).
            </li>
            <li>
              <u>What:</u> Make sure the documents are clear, legible, and
              error-free. The system may guide you through the upload process
              and indicate the required file formats (PDF, JPG, etc.).
            </li>
          </ul>
          <h3>4. Self-Attestation via Digital Signature</h3>
          <ul className="lead mb-3 fs-4 lh-sm">
            <li>
              <u>How:</u> Instead of physically signing documents, the system
              will allow you to digitally sign and self-attest your documents.
              This can be done via an e-signature feature integrated into the
              platform or Adhaar OTP verification consent
            </li>
            <li>
              <u>What:</u> You will authenticate your submission with a valid
              digital signature, ensuring the authenticity and security of the
              documents
            </li>
          </ul>
          <h3>5. Submit the Application Online</h3>
          <ul className="lead mb-3 fs-4 lh-sm">
            <li>
              <u>How:</u> Once the form is complete and documents are uploaded,
              you can submit your application with a single click through the
              portal or app.
            </li>
            <li>
              <u>What:</u> You will receive an immediate confirmation email or
              SMS acknowledging your submission. Your application will be
              processed for review and verification.
            </li>
          </ul>
          <h3>6. Loan Processing and Verification</h3>
          <ul className="lead mb-3 fs-4 lh-sm">
            <li>
              <u>How:</u> MicrofinanceBazar will process your loan application
              online, using digital tools for document verification and credit
              assessment. You may be asked for additional information or
              clarification through the messaging system
            </li>
            <li>
              <u>What:</u> Wait for the loan assessment to be completed for 3
              Working days. During this time, MicrofinanceBazar will check the
              validity of the submitted information, and you may receive updates
              on your application's status via whatsapp or text, registered
              speed post.
            </li>
          </ul>
          <h3>7. Approval and Disbursement</h3>
          <ul className="lead mb-3 fs-4 lh-sm">
            <li>
              <u>How:</u> If your loan is approved, MicrofinanceBazar will send
              an offer letter and details about the loan terms (interest rate,
              repayment schedule, etc.) through email/speedpost. You’ll accept
              the offer digitally by signing the agreement.
            </li>
            <li>
              <u>What:</u> Once you accept the loan terms, the funds will be
              disbursed directly to your bank account or payment method, as per
              the terms.
            </li>
          </ul>
        </div>
      </section>
    </>
  );
}

export default WhyMicrofinanceBazar;
